import {Walkthrough} from '@core/types/walkthrough';
import {defineAsyncComponent} from 'vue';

/**
 * Gastat-specific create-application tour. Step selectors target real DOM/CSS
 * hooks; UI refactors can break the flow without type errors—keep in sync with
 * the app or cover with E2E for this walkthrough.
 */
export const createApplicationWalkthrough: Walkthrough = {
  id: 'create-application',
  title: 'walkthroughs.createApplication.title',
  description: 'walkthroughs.createApplication.description',
  steps: [
    {
      id: 'step-1-gastat',
      targetSelector: 'label[for="toggle-more"]',
      title:
        'externalDevPortal.walkthroughs.createApplication.step1Gastat.title',
      content:
        'externalDevPortal.walkthroughs.createApplication.step1Gastat.content',
      location: 'bottom',
      actionRequired: 'click',
      waitForSelector: '#more-menu a[href="/applications"]',
    },
    {
      id: 'step-1-gastat-sub',
      targetSelector: '#more-menu a[href="/applications"]',
      title: 'walkthroughs.createApplication.step1.title',
      content: 'walkthroughs.createApplication.step1.content',
      location: 'right',
      actionRequired: 'click',
      waitForSelector: '.create-application-btn',
    },
    {
      id: 'step-2',
      targetSelector: '.create-application-btn',
      title: 'walkthroughs.createApplication.step2.title',
      content: 'walkthroughs.createApplication.step2.content',
      location: 'bottom',
      actionRequired: 'click',
      waitForSelector: '#application-name-field',
    },
    {
      id: 'step-3',
      targetSelector: '#application-name-field',
      title: 'walkthroughs.createApplication.step3.title',
      content: 'walkthroughs.createApplication.step3.content',
      location: 'bottom',
      showNext: true,
      isValid: () => {
        const input = document.querySelector(
          '#application-name-field input',
        ) as HTMLInputElement;
        return (input?.value?.length ?? 0) >= 4;
      },
    },
    {
      id: 'step-4',
      targetSelector: '.application-selectedProducts-field',
      title: 'walkthroughs.createApplication.step4.title',
      content: 'walkthroughs.createApplication.step4.content',
      location: 'top',
      showNext: true,
      isValid: () => {
        const field = document.querySelector(
          '.application-selectedProducts-field',
        );
        // Look for chips inside the Select component
        return (field?.querySelectorAll('.chip').length ?? 0) > 0;
      },
    },
    {
      id: 'step-5',
      targetSelector: '#create-application-submit',
      title: 'walkthroughs.createApplication.step5.title',
      content: 'walkthroughs.createApplication.step5.content',
      location: 'bottom',
      actionRequired: 'click',
      waitForSelector: '#application-detail-page',
    },
    {
      id: 'step-6',
      location: 'center',
      component: defineAsyncComponent(
        () => import('@walkthroughs/components/CurlCommandStep.vue'),
      ),
    },
  ],
};
